export const ComercialPolitics = [
  'Distribuidor',
  'Hospitalar',
  'Cesta básica',
  'Concessionária'
];
